import React from "react";

const Error = () => {
  return (
    <div>
      <div
        className="justify-content-center align-middle fw-bold"
        style={{ height: "320px" }}
      >
        404
      </div>
      <div>sorry nothing is here. You are at the end of the internet. </div>
    </div>
  );
};

export default Error;
